import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "",

        async checkHash({ hash = "" }) {
            const url = this.url(`/password/hash/${hash}`);

            return Vue.http.get(url);
        },

        async recoverPassword(data) {
            return Vue.http.post(this.url("/password-recovery"), {
                hash: data.hash,
                password: data.password,
            });
        },

        async invalidateRecovery({ hash }) {
            return Vue.http.delete(this.url(`/invalidate-recovery/${hash}`));
        },
    },
    base
);
